module.exports = __webpack_public_path__ + "img/nothing.a19a34aa.png";